export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_19.a7edc82d.jpg";